import { MatSnackBar } from "@angular/material/snack-bar";
import { Component, OnInit } from "@angular/core";
import { Country } from "../_models/country";
import { ProductContent } from "../_models/product-content";
import { CountryService } from "../_services/country.service";
import { Location } from "@angular/common";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";

@Component({
  selector: "app-add-country-page",
  templateUrl: "./add-country-page.component.html",
  styleUrls: ["./add-country-page.component.scss"],
})
export class AddCountryPageComponent implements OnInit {
  public isModified = false;
  public newProductContent = new ProductContent();
  public country: Country;
  public showAddContents = true;
  public currencies = ["PHP", "USD"];

  constructor(
    private location: Location,
    public snackBar: MatSnackBar,
    public countryService: CountryService,
    private router: Router
  ) {}

  public back(): void {
    this.location.back();
  }

  public dataChanged(): void {
    this.isModified = true;
  }

  public getImageUrl(): string {
    return environment.imageUrl;
  }

  public ngOnInit(): void {
    this.country = new Country();
    this.country.currencyCode = "";
  }

  isCountryValid() {
    return this.country.name && this.country.code;
  }

  public save(): void {
    if (!this.isCountryValid()) {
      this.showErrorMessage("Name or code is required");
      return;
    }

    this.countryService.addCountry(this.country).subscribe(
      (country) => {
        this.showSuccessMessage("Country was added successfully!");
        this.router.navigate(["regional", "country"]);
      },
      (err) => {
        console.error(err);
        if (err.status == 400) {
          this.showErrorMessage("Invalid values");
        } else {
          this.showErrorMessage(
            "Sorry, your request cannot be process at the moment!"
          );
        }
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  public showSuccessMessage(message): void {
    this.snackBar.open(message, "Success", {
      duration: 2000,
    });
  }
}
